import React, { Component } from "react"
import { Row, Col } from "reactstrap"

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer"  style={{ backgroundColor: '#ffffff' }}>
          <div className="container-fluid">
            <Row>
              <Col sm={6} style={{ paddingLeft: '20px' }}>
                {new Date().getFullYear()} © <a href="https://www.wechiptech.com" target="_blank" rel="noopener noreferrer">Wechip</a>
              </Col>
              <Col sm={6}>
                <div className="text-sm-end d-none d-sm-block">
                  <a href="https://www.wechiptech.com" target="_blank" rel="noopener noreferrer">Wechip</a>
                </div>
              </Col>
            </Row>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}
export default Footer;